import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from 'react-router-dom';
import { getConfigValue } from "../util/getConfigValue";
import { AppContext } from "../util/AppContext";

Breadcrumb.propTypes = {
	items: PropTypes.array
};

function Breadcrumb({ items = [] }) {
    const [appState] = useContext(AppContext);
    const location = useLocation();

    if (!items.length) return null;

    if (location.pathname.toLowerCase() === "/") return null;

    return (
        <nav aria-label="breadcrumb" className="nav-breadcrumb-wrapper">
            <div className="container-xl">
                <div className="row">
                    <div className="col-12">
                        <ol className="nav-breadcrumb">
                            <Link to="/" className="nav-breadcrumb-item">
                                <span className="fas fa-house"></span>
                                <span className="sr-only">{getConfigValue(appState?.config?.Common.Home, appState)?.Value || null}</span>
                            </Link>
                            {items.map((item, idx) => (                                
                                <li key={item.label} className={`nav-breadcrumb-item ${idx === items.length - 1 ? "active" : ""}`} aria-current={idx == items.length - 1 ? "page" : undefined}>
                                    {idx == items.length - 1 ? (
                                        item.label
                                    ) : (
                                        item.path === "#" ?
                                            <a href="#">{item.label}</a> :
                                            <Link to={item.path} className="nav-breadcrumb-item">{item.label}</Link>
                                    )}
                                </li>
                            ))}
                        </ol>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default Breadcrumb;